module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAAAXNSR0IArs4c6QAAATxJREFUOE+lU7FKA0EUnLfnJWwOFRPiFwiCWKhYKxIQIYVWfoEgKcTC3srCzkIFwcJSsbC6oB+gIGKpRQgWmi5VNOdpkr19ksQ7L4EDyW21zHuzM/t2lhCxPq6QMRMY1Q18pTxUaR1efyuFAWYIp4hFIZATQNavEeBqxoNUsGkV9RDe3VYuITMWCkSYjHJDjHcGjmUer+2eQNm1sUUC01FEH2eNurSwR0uodcjNG8x5Gpu9RIPE2PywdkouWjXVU2PcyzzOOmS3iG0iTPkNIp1Lm7Pny5TIjoBbSr3s36nybilQZyiZwk6XbOOQBBJ+MblQXiNrYjxQY89r3s5caOfpMxAwcED8CPO7iqM/WwLJlcYG0ZAIW1XPhWv1dlLxMYNxGk859p1jTft3aIO9c+yEtQ8YONv9sfzPr/oBlSCpM1MVvh4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/yellowIcon.png
// module id = 5Rws
// module chunks = 1